import LazyLoad from "vanilla-lazyload";
import Masonry from "masonry-layout";
import Cookies from "js-cookie";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import zenscroll from "zenscroll";
import Player from "@vimeo/player";

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const main = document.querySelector("main");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
const overlayInner = overlay.querySelector(".inner");
const overlayCloser = overlay.querySelector(".closer");

window.addEventListener("load", function () {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  //INTRO ANIMATION ===================================
  const introEl = this.getElementById("intro");
  if (typeof introEl != "undefined" && introEl != null) {
    const sceneOne = introEl.querySelector(".scene1");
    const sceneTwo = introEl.querySelector(".scene2");

    let introSlideshowEl = document.querySelector(".intro-slideshow");
    let flktyIntro = new Flickity(introSlideshowEl, {
      fade: true,
      autoPlay: 2000,
      pauseAutoPlayOnHover: false,
      cellSelector: ".cell",
      prevNextButtons: false,
      pageDots: false,
    });

    // pause the autoplay slideshow, we will start it when the fade in happens
    flktyIntro.pausePlayer();

    // fade in the logo
    setTimeout(function () {
      sceneOne.classList.add("active");
    }, 500);

    // fade out the logo
    setTimeout(function () {
      sceneOne.classList.add("off");
    }, 2500);

    // fade in the slideshow
    setTimeout(function () {
      flktyIntro.playPlayer();
      sceneTwo.classList.add("active");
    }, 3000);

    // fade out the intro, animate up the site content
    setTimeout(function () {
      introEl.classList.add("off");
      body.classList.remove("loading");

      // target all fadeup elements and animate them in
      let fadeUps = document.querySelectorAll(".fadeUp");
      gsap.to(fadeUps, { opacity: 1, y: 0, stagger: 0.15 });

      // add a cookie to disable the intro for 7 days
      Cookies.set("saw_intro", "yes", { expires: 7 });
    }, 8500);

    setTimeout(function () {
      // remove the introEl from the DOM
      introEl.parentNode.removeChild(introEl);
    }, 10000);
  }
  // ===============================

  // global animation effects
  ScrollTrigger.batch(".fadeUp", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
    },
  });

  ScrollTrigger.batch(".fadeOn", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, stagger: 0.1 });
    },
  });

  setTimeout(function () {
    ScrollTrigger.batch(".fadeUpDelay", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
      },
    });
  }, 300);

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  function loadInit() {
    //initialize lazyload - sitewide for image
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });

    //initialize lazyload - autoplay videos
    const lazyLoadAutoVideo = new LazyLoad({
      elements_selector: ".autovideo",
      threshold: 30,
      callback_enter: playAutoVideo,
      callback_exit: pauseAutoVideo,
    });
  }

  loadInit();

  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  //initialize flickity for slideshows

  function slideshowInit() {
    let slideshowEl = document.querySelector(".slideshow");
    if (typeof slideshowEl != "undefined" && slideshowEl != null) {
      let flkty = new Flickity(slideshowEl, {
        // options
        fade: false,
        cellSelector: ".cell",
        prevNextButtons: false,
        pageDots: false,
      });

      // add event listeners for left/right arrows
      const prevArrow = document.querySelector(".arrowbar .arrow.left");
      const nextArrow = document.querySelector(".arrowbar .arrow.right");

      nextArrow.addEventListener("click", function (e) {
        e.preventDefault();
        flkty.next();
      });

      prevArrow.addEventListener("click", function (e) {
        e.preventDefault();
        flkty.previous();
      });
    }
  }

  slideshowInit();

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.play();
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    imgpath = "/images/pics/" + img;

    /*

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = "/images/pics/1920/" + img;
      } else {
        imgpath = "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    */

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    body.classList.add("overlay-on");
    overlay.classList.add("on");
  }

  function closeOverlay() {
    body.classList.remove("overlay-on");
    overlay.classList.remove("on");
    overlayInner.innerHTML = "";
    // reset the URL based on the data-slug value found in body tag
    let slug = body.getAttribute("data-slug");
    history.pushState(null, null, slug);
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {}

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // full video embed playback
  let playBtns = document.querySelectorAll(".playBtn");
  playBtns.forEach((playBtn) => {
    playBtn.addEventListener("click", function (e) {
      e.preventDefault();
      let cell = playBtn.closest(".cell");

      // target the iframe element and attach to Vimeo API
      let iframeEl = cell.querySelector("iframe");
      let videoEl = cell.querySelector("video.full");

      if (typeof iframeEl != "undefined" && iframeEl != null) {
        // make sure iframeEl has "vimeo" in the src attribute, if found use the Vimeo API to autoplay
        if (iframeEl.src.indexOf("vimeo") >= 0) {
          let player = new Player(iframeEl);
          player.play();
        }
      }

      if (typeof videoEl != "undefined" && videoEl != null) {
        if (videoEl.classList.contains("sizeload")) {
          sizeloadVideo(videoEl, "no");
        }
        videoEl.play();
      }

      cell.classList.add("fullplaying");
    });
  });

  // SCROLL ==================================
  let st = 0;
  let lastScrollTop;
  window.addEventListener("scroll", function () {
    let isMenuOn = body.classList.contains("menuOn");
    st = window.pageYOffset || document.documentElement.scrollTop;

    // HEADER show/hide on scroll up/down
    //ONLY if the mobile menu button is not on
    if (!isMenuOn) {
      if (st > lastScrollTop) {
        body.classList.add("scroll_down");
        body.classList.remove("scroll_up");
      } else {
        if (st > 100) {
          body.classList.remove("scroll_down");
          body.classList.add("scroll_up");
        }
      }
    }

    // reset back to static state at top of the page
    if (st < 100 && !isMenuOn) {
      body.classList.remove("scroll_down", "scroll_up");
    }

    lastScrollTop = st;
  });

  // ARTIST hover events that displays media
  let artistLinks = document.querySelectorAll(".artist_hover a");
  artistLinks.forEach((artistLink) => {
    artistLink.addEventListener("mouseenter", function (e) {
      e.preventDefault();
      let artistId = artistLink.getAttribute("data-id");
      // target the artistBgCell with matching ID
      let activeCell = document.querySelector(
        ".artist_hover .cell[data-id='" + artistId + "']"
      );
      // TODO: we should check for video content, if found, need to start playing the video
      activeCell.classList.add("active");
    });
    artistLink.addEventListener("mouseleave", function (e) {
      e.preventDefault();
      let artistId = artistLink.getAttribute("data-id");
      // target the artistBgCell with matching ID
      let activeCell = document.querySelector(
        ".artist_hover .cell[data-id='" + artistId + "']"
      );
      // TODO: we should check for video content, if found, need to reset the video to 0
      activeCell.classList.remove("active");
    });
  });

  // FILTER BUTTON ===============
  //Filter button clicks
  let filterBtns = document.querySelectorAll(".filter a");
  filterBtns.forEach((filterBtn) => {
    filterBtn.addEventListener("click", function (e) {
      //e.preventDefault();
      //alert("filter btn clicked");
    });
  });

  //Mobile filter dropdown
  let filter = document.querySelector(".filter");
  let filterList = document.getElementById("filter-list");

  if (typeof filterList != "undefined" && filterList != null) {
    let options = filterList.querySelectorAll("li");

    options[0].addEventListener("click", function () {
      filterList.classList.toggle("show-options");
    });

    options.forEach((option) => {
      option.addEventListener("click", function () {
        options.forEach((opt) => opt.classList.remove("active"));
        option.classList.add("active");
        options[0].innerText = option.innerText;
        optionsList.classlist.remove("show-options");
      });
    });
  }

  // overlay links
  let overlayLinks = document.querySelectorAll(".openOverlay");
  overlayLinks.forEach((overlayLink) => {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      let id = overlayLink.getAttribute("data-id");
      getAjax("/getItem.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        openOverlay();
      });
    });
  });

  // project links
  let projectLinks = document.querySelectorAll(".openProject");
  projectLinks.forEach((projectLink) => {
    projectLink.addEventListener("click", function (e) {
      e.preventDefault();
      let id = projectLink.getAttribute("data-id");
      let href = projectLink.getAttribute("href");
      getAjax("/getProject.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        loadInit();
        slideshowInit();
        openOverlay();

        // full video embed playback
        let playBtns = overlayInner.querySelectorAll(".playBtn");
        playBtns.forEach((playBtn) => {
          playBtn.addEventListener("click", function (e) {
            e.preventDefault();
            let cell = playBtn.closest(".cell");

            // target the iframe element and attach to Vimeo API
            let iframeEl = cell.querySelector("iframe");
            let videoEl = cell.querySelector("video.full");

            if (typeof iframeEl != "undefined" && iframeEl != null) {
              // make sure iframeEl has "vimeo" in the src attribute, if found use the Vimeo API to autoplay
              if (iframeEl.src.indexOf("vimeo") >= 0) {
                let player = new Player(iframeEl);
                player.play();
              }
            }

            if (typeof videoEl != "undefined" && videoEl != null) {
              if (videoEl.classList.contains("sizeload")) {
                sizeloadVideo(videoEl, "no");
              }
              videoEl.play();
            }

            cell.classList.add("fullplaying");
          });
        });

        // update the URL
        history.pushState(null, null, href);
      });
    });
  });

  //hamburger menu toggle

  if (typeof menuBtn != "undefined" && menuBtn != null) {
    menuBtn.addEventListener(
      "click",
      function (event) {
        event.preventDefault(), document.body.classList.toggle("menuOn");
      },
      true
    );
  }

  // close overlay
  overlayCloser.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      closeOverlay();
    },
    true
  );
});
